import { useRef } from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import Image from 'next/image';
import ButtonFill from '../ui/ButtonFill';
import gsap from "gsap";
import { useGSAP } from '@gsap/react';
import Link from 'next/link';


const HomeProjects = ({ title, items, text, btn_text, btn_item_text }) => {


  const [emblaRef] = useEmblaCarousel({ align: 'start' });

  const itemsRefs = useRef([]);
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const textRef = useRef(null);
  const containerRef = useRef(null);


  useGSAP(() => {
    const mm = gsap.matchMedia();

    mm.add("(min-width: 1280px)", () => {

      if (titleRef.current) {
        gsap.fromTo(titleRef.current, { opacity: 0 }, {
          opacity: 1,
          duration: 1,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 70%",
          },
        });
      }

      if (textRef.current) {
        gsap.fromTo(textRef.current, { opacity: 0 }, {
          opacity: 1,
          duration: 1,
          delay: 0.2,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 70%",
          },
        });
      }

      gsap.fromTo(containerRef.current, {
        y: '13rem'
      },
          {
        y: 0,
        ease: "none",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top bottom", 
          end: "top 60%",  
          scrub: 0.1,  
        },
      });

      const offsets = [10, 30, 20, 15];

      itemsRefs.current.forEach((item, index) => {
        const initialY = offsets[index] !== undefined ? offsets[index] : 0;

        gsap.fromTo(item, {
          y: `${initialY}rem`,

        }, {
          y: 0,
          duration: 1,
          delay: index * 0.1,
          scrollTrigger: {
            trigger: item.parentElement,
            start: "top 100%",
            end: "top 40%",
            // markers: true,
            scrub: 0.5
          },
        });


        const imageElement = item.querySelector('img');
        if (imageElement) {
          gsap.fromTo(imageElement, {
            y: '-4rem',
          }, {
            y: '4rem',
            ease: "none",
            scrollTrigger: {
              trigger: item.parentElement,
                start: "top bottom",
                end: "bottom start",
              scrub: 0,
            },
          });
        }

      });


    });

    return () => mm.revert();
  }, {scope: sectionRef, dependencies: items}); 

  return (
    <section ref={sectionRef} className="container-max w-full py-[4rem]  md:py-[6rem] lg:py-[8rem] xl:py-[10rem]">
      <div ref={containerRef} className='flex flex-col w-full'>
        <div className='mb-[2.4rem] md:mb-[4rem] lg:mb-[8rem] text-left container-padding flex-col container-grid'>
          <h2 ref={titleRef} className='w-full md:mb-0 lg:text-right md:col-span-2 mb-[2rem] lg:col-span-3 lg:col-start-3'>{title}</h2>
          <p ref={textRef} className='pr-[16%] text-1 lg:flex lg items-center md:col-span-2 md:col-start-4 lg:col-span-4 lg:col-start-7'>{text}</p>
        </div>



        <div className="embla lg:hidden mb-[2.4rem] md:mb-[4rem] px-[2rem] md:px-[2.4rem]" ref={emblaRef}>
          <div className="embla__container gap-[1.2rem] md:gap-[1.6rem]">
            {items.map((item, index) => (
              <div key={index} className="embla__slide flex flex-col w-[calc(100%-4rem)] md:flex-row items-stretch flex-[0_0_31.6rem] md:flex-[0_0_59.6rem]">
                <div className="relative aspect-[1.44/1] md:min-w-[28.9rem] md:aspect-auto w-full">
                  <Image
                    src={item.image.url}
                    alt={item.image.alt} 
                    fill
                    sizes="300px"

                    className="w-auto parallax-image object-cover"
                  />
                </div>

                <div className="bg-dusty-green-light flex-1 md:flex-initial flex flex-col justify-between p-[2rem]">
                  <div>
                    <h3 className="mb-[1.6rem] heading-4 md:mb-[2.4rem]">{item.title}</h3>
                    <p className="text-1 text-dark-blue mb-[1.6rem]">{item.description}</p> 

                    <div className='flex mb-[4.8rem] md:mb-[6rem] w-full justify-between items-end'>
                      <p className='caption text-dark-blue opacity-60 w-[12.4rem]'>{item.city}</p> 
                      <p className='caption text-dark-blue opacity-60'>{item.year}</p> 
                    </div>
                  </div>

                  <a href={item.link} className="text-link text-dark-blue">{btn_item_text}</a> 
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="hidden lg:flex container-padding mb-[4rem]">
          <div className=" flex w-full gap-[3.6rem] lg:gap-[5.2rem]">
            {items.map((item, index) => (
              <div key={index} ref={el => {
                if (el) {
                  itemsRefs.current[index] = el;
                }
              }}       className={`
          relative card  flex group flex-col
          ${index === 0 || index === 3 ? 'w-[22.35%]' : 'w-[27.65%]'}
        `}>
                <a href={item.link} aria-label={'Смотреть проект'} className=' overflow-hidden w-full mb-[1.2rem] relative'>
                  <div className={`relative overflow-hidden flex items-center ${index === 0 || index === 3 ? 'aspect-[0.703/1]' : 'aspect-[0.87/1]'} justify-center  w-full`}>
                    <div className='overflow-hidden flex items-center justify-center w-full h-[calc(100%-2px)]'>
                      <div className='relative w-full h-[130%]'>
                        <Image
                          src={item.image.url}
                          alt={item.image.alt} 
                          fill
                          fetchPriority={index === 0 ? 'high' : 'auto'}
                          priority={index === 0 ?  true : false}
                          sizes="600px"
                          className="w-auto object-cover"
                        />
                      </div>
                    </div>
                  </div>

                  <div className='bg-dusty-green-light card-polygon-overlay absolute inset-0 scale-[1.01]'></div>
                  <div className='bg-dusty-green-light group-hover:opacity-100 opacity-0 transition-opacity scale-[1.01] duration-500 absolute inset-0 '></div>


                  <div className="absolute z-10 group-hover:opacity-100 opacity-0 transition-opacity duration-500 inset-0 flex w-full items-start flex-col justify-between  p-[2rem] lg:px-[2rem] lg:py-[3.2rem]">
                    <p className="text-dark-blue text-link mb-auto">{btn_item_text}</p> 
                    <div>
                      <p className="text-1 text-dark-blue mb-[4rem]">{item.description}</p> 
                      <div className='flex w-full justify-between items-end'>
                        <p className='caption text-dark-blue w-[12.4rem] xl:w-[15rem] opacity-60'>{item.city}</p> 
                        <p className='caption text-dark-blue opacity-60'>{item.year}</p> 
                      </div>
                    </div>
                  </div>
                </a>
                <h3 className="mb-[1.6rem] heading-4">{item.title}</h3>
              </div>
            ))}
          </div>
        </div>

        <div className='container-padding flex flex-col lg:items-center lg:justify-center'>
          <ButtonFill isLink={true} href={'/proekty'} className='md:w-fit text-nowrap'>
            {btn_text}
            <img className="ml-[1.2rem] -rotate-45" loading='lazy' fetchPriority="low" src="/images/arrow_right.svg" alt="Стрелка вправо" />
          </ButtonFill>
        </div>
      </div>



    </section>
  );
};

export default HomeProjects;